export const STORAGE_KEYS = {
	BV_SYSTEM_BUSINESS_UNIT: 'BV_SYSTEM_BUSINESS_UNIT',
	BV_SYSTEM_SALES_AGENT: 'BV_SYSTEM_SALES_AGENT',
	BV_CUSTOMER_SUMMARY: 'BV_CUSTOMER_SUMMARY',
	BV_ORDER_SUMMARY: 'BV_ORDER_SUMMARY',
	BV_SYSTEM_IS_ADMIN: 'BV_SYSTEM_IS_ADMIN',
	BV_SYSTEM_SALES_GROUP: 'BV_SYSTEM_SALES_GROUP',
};
